import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';
import { Sidebar, SideBarGerencial, SideBarFinancas, Topbar, Footer } from './components';
import {
  AMODULO_SISAREPASSENGER, AMODULO_FINANCAS, AMODULO_GERENCIAL, AMODULO_RECEPTIVO, AMODULO_ADMAPPCLI,
  AMODULO_FROTAS,
  AMODULO_CRM
} from '../../consts';
import ChosenBar from './components/ChosenBarSide/ChosenBarSide';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}));

/* retorna código módulo da rota */
function getModuloRota() {
  const location = useLocation();
  const rota = location.pathname;

  const parteRotaGerencial = '/gerencial/';
  const parteRotaFront = '/front/'
  const parteRotaFinancas = '/financas/';
  const parteRotaAppCli = '/appcli/';
  const parteRotaAdmAppCli = '/admappcli/';
  const parteRotaFrotas = '/frotas/';
  const parteRotaCRM = '/crm/';

  if (rota.includes(parteRotaGerencial)) {
    return AMODULO_GERENCIAL
  }
  else if (rota.includes(parteRotaFront)) {
    return AMODULO_RECEPTIVO
  }
  else if (rota.includes(parteRotaFinancas)) {
    return AMODULO_FINANCAS
  }
  else if (rota.includes(parteRotaAppCli)) {
    return AMODULO_SISAREPASSENGER
  }
  else if (rota.includes(parteRotaAdmAppCli)) {
    return AMODULO_ADMAPPCLI
  }
  else if (rota.includes(parteRotaFrotas)) {
    return AMODULO_FROTAS
  }
  else if (rota.includes(parteRotaCRM)) {
    return AMODULO_CRM

  } else {
    console.log('A rota não contém a parte:', parteRotaGerencial);
  }

}

const Main = props => {
  const { children } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  //const isModuloGerencial = true;
  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}
    >
      <Topbar fantasia={sessionStorage.getItem('fantasia')} onSidebarOpen={handleSidebarOpen} />

      <ChosenBar
        modulo={getModuloRota()}
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
      />

      <main className={classes.content}>
        {children}
        <Footer />
      </main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
